import React,{useCallback,useState,useContext} from 'react'

// import Section from '../../components/components/Section'

import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import SiteSeo from '../../../../components/components/seo/SiteSeo'
import AllDetails from '../../../../components/components/Blog/AllDetails'
import { useTranslation } from 'next-i18next'
import getSlugFunction from "../../../api/cms/slug/getSlugFunction";
import *  as config from '../../../../next.config.js'
import { useRouter } from "next/router";
import { printLogs,stripeHTMLTags } from '../../../../components/helpers/helpers';
import { getvocabTermsObj } from "../../../api/globals/terms/helpers";
import KeyWordsData from '../../../../components/components/KeyWords/KeyWords'
import buildQueryForKeywordsFunction from '../../../api/cms/keywords/buildQueryForKeywordsFunction'
import getBlogFunction from '../../../api/cms/blog/getBlogFunction'
import getIncludeStatusIdsFromBack from '../../../api/globals/terms/getIncludeStatusIdsFromBack'
import NotFound from '../../../../components/components/NotFound'
// import {} from '../../../../components/components/help'
import Statistics from "../../../../components/components/Statistics";
import TermsContext from "../../../../context/Trems"
function Details(props) {
  const vocabTerms= useContext(TermsContext)
  const { t } = useTranslation("common")
  const [post ,setPost]=useState([])
  const router = useRouter()
  const callback = useCallback(
    back => {
      setPost(back)
    },
    []
  );

  let meta = null
  if(JSON.parse(props.blogDetails).length>0){
  
     meta = [
      {
        name: "description",
        content:stripeHTMLTags(JSON.parse(props.blogDetails)[0].transBlog[0].body).substr(0, 1000),
         image: post.image !=null ?post.image:config.basePath+"/assest/defaultBlogImage.svg",
         url:config.env.baseUrl+router.asPath
      }
    ];
  }

 
    return (
      JSON.parse(props.blogDetails).length>0?<div>
        
        <SiteSeo title={JSON.parse(props.blogDetails)[0].transBlog[0].title } meta={meta}/>
        <KeyWordsData keyWords={JSON.parse(props.keyWords)}/>
  
        <Statistics entityId={props.entityId[0]}  statisticsCode={"blog"}/>
        <AllDetails
          entityId={props.entityId}
          blogType={props.blogType}
          callback={callback}
          blogDetails={JSON.parse(props.blogDetails)}
         />
         <br/>
          <br/>

        </div>:<NotFound/>
    )
}

export default Details
export async function getServerSideProps({params,locale,req}) {

  let slugData= {}
  let entityId 
  let slugId=[]
  let  blogType
  let slugEntityClasses = await getvocabTermsObj(
    { vocabCode: ["slug-entity-classes"],pageId:1},

    req
  );

  let slugEntityClassesTypes = await getvocabTermsObj(
    { vocabCode: ["slug-entity-class-types"],pageId:1 },
    req
  );
  if(params.Details){
   slugData.url=JSON.stringify([params.Details])
   slugData.lang=locale
   if(slugEntityClasses.filter(ele=>ele.code=="blog").length>0){
  
   }

  if(slugEntityClassesTypes.filter(ele=>ele.code==params.type).length>0){
    slugData.alternativeUrl=JSON.stringify([slugEntityClassesTypes.filter(ele=>ele.code==params.type)[0].code])
  }
   if(/\d+/g.test(params.Details)){
    entityId=[params.Details]
  }else{
    let slugResult = await getSlugFunction(slugData, req);
    if(slugResult.length>0){
      entityId =[slugResult[0].entityId]
      slugId=slugResult[0].id
    }
  }
   blogType = params.type

}

let dataOfQuery={}
if(slugId){
  dataOfQuery.slugId=[slugId]
}
dataOfQuery.langCode=locale
dataOfQuery.slugEntityClass=["blog"]
dataOfQuery.slugEntityClassType=[params.type]
let getKeywords=await buildQueryForKeywordsFunction(dataOfQuery,req)
// let getBlogTypes=await getvocabTermsObj({vocabCode: ["blog-types"],pageId:1 },req);
let blogParams={}

if(entityId){
  blogParams.id=entityId
  blogParams.langId=locale
}
// if(getBlogTypes.filter(ele=>ele.code==params.type).length>0){
//   // blogParams.blogTypeCode=JSON.stringify([getBlogTypes.filter(ele=>ele.code==params.type)[0].id])
// }
let Statuscodes = {
  vocabCode: [
    "maker-checker-entity-status",
    "maker-checker-status",
    "maker-only-status"
  ]
};
let StatusIds = await getIncludeStatusIdsFromBack(Statuscodes, req);
blogParams.getBlogSlug= ""
blogParams.statusId=StatusIds
const result = await getBlogFunction(blogParams,req)
    return {
      props: {
        keyWords:JSON.stringify(getKeywords.content),
        blogDetails:JSON.stringify(result.data),
        entityId:entityId?entityId:null,
        blogType:blogType?blogType:null,
        ...(await serverSideTranslations(locale, ["common"]))
    
      }
    }};